import { useBrandOptions } from '~/components/kiosk/kiosk-ten-dlc/composables/useBrandOptions';
import { identityStatusLabels } from '~/components/kiosk/kiosk-ten-dlc/registration/tenDlcRegistrationLabels';
import { adminTenDlcRegistrationClient } from '~/services';
import type { TcrLiveBrand } from '~/services/adminTenDlcRegistrationClient.types';

export type BrandOption = { label: string; value: string; selectable: boolean };

const toOption = (brand: TcrLiveBrand): BrandOption => ({
    value: brand.brand_id,
    label: `${brand.brand_id} - ${brand.display_name ?? ''} (${
        brand.identity_status ? identityStatusLabels[brand.identity_status] : 'Verifying'
    })`,
    // Campaigns are blocked while a brand is unverified.
    selectable: ['VERIFIED', 'VETTED_VERIFIED'].includes(brand.identity_status ?? ''),
});

export const useTcrLiveBrandOptions = (selectedBrandId: () => string | undefined) =>
    useBrandOptions(
        selectedBrandId,
        (query) =>
            adminTenDlcRegistrationClient
                .getBrands({ display_name: query })
                .then((response) => response.data.data.map(toOption)),
        (brandId) => adminTenDlcRegistrationClient.getBrand(brandId).then((response) => toOption(response.data.brand))
    );
